import { themeStyle } from '@repo/ui/theming';
import { layeringCSSVariables } from '@repo/ui-kit/css/utils';
import styled from 'styled-components';

export const Wrapper = styled.div<{
  opacity?: number;
  isDark?: boolean;
}>`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: ${({ isDark = true, opacity = 0.6 }) =>
    isDark ? `rgba(0, 0, 0, ${opacity})` : `rgba(255, 255, 255, ${opacity})`};
  backdrop-filter: blur(4px);
  z-index: ${layeringCSSVariables.zIndexGlobalIndicator};

  display: flex;
  gap: var(--spacing-8);
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const SpinnerWrapper = styled.div`
  .spinner {
    animation: rotate 2s linear infinite;
    position: relative;

    & .path {
      stroke: ${themeStyle.inkLight};
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;
